<template>

  <section id="dashboard-ecommerce">

    <b-row class="match-height ">
      <b-col cols="12">
        <toggle-collapse :show-date-time="false">
          <dashboard-filter :filterDashboard="filterDashboard" />
        </toggle-collapse>
      </b-col>
    </b-row>

    <div>
      <b-tabs>

        <b-tab active @click="changeTab('Devices')" v-if="showDevicesTab">

          <template #title>
            <feather-icon icon="TruckIcon" size="33" />
            <span style="font-size:1.5rem">{{ $t('Devices Statistics') }}</span>
          </template>
          <div>

            <b-row class="match-height">


              <b-col xl="12" md="12">
                <div class="loading_page" v-if="devices_data.loading">
                  <orbit-spinner :animation-duration="1000" :size="100" :color="'#0e96b1'" />
                </div>

                <devices-statistics :data="devices_data.data"/>

              </b-col>

            </b-row>

            <devices-statistics-by-category :data="categories_data.data" :loading="devices_data.loading" />

          </div>
        </b-tab>

        <b-tab @click="changeTab('Services')" v-if="showServicesTab">
          <template #title>
            <feather-icon icon="ToolIcon" size="33" />
            <span style="font-size:1.5rem">{{ $t('Services Statistics') }}</span>
          </template>
          <b-row class="match-height">

            <b-col lg="6" md="6" v-if="rain_data.data !== undefined && widgets.includes('Rain')">
              <div class="loading_page" v-if="rain_data.loading">
                <orbit-spinner :animation-duration="1000" :size="100" :color="'#0e96b1'" />
              </div>
              <GeneralServicesChart :data="rain_data.data"   :chartInfo="{title:'Rain statistics',type:'rain'}" />

            </b-col>

            <b-col lg="6" md="6" v-if="sweep_data.data !== undefined && widgets.includes('Sweep')">
              <div class="loading_page" v-if="sweep_data.loading">
                <orbit-spinner :animation-duration="1000" :size="100" :color="'#0e96b1'" />
              </div>
              <sweep-widget :data="sweep_data.data" />

            </b-col>

            <b-col lg="6" md="6" v-if="wash_data.data !== undefined && widgets.includes('Containers')">
              <div class="loading_page" v-if="container_data.loading">
                <orbit-spinner :animation-duration="1000" :size="100" :color="'#0e96b1'" />
              </div>
              <containers-statistics :data="container_data.data"/>

            </b-col>

            <b-col lg="6" md="6" v-if="wash_data.data !== undefined && widgets.includes('Wash')">
              <div class="loading_page" v-if="wash_data.loading">
                <orbit-spinner :animation-duration="1000" :size="100" :color="'#0e96b1'" />
              </div>
              <WashWidget :data="wash_data.data"  />

            </b-col>

            <b-col lg="6" md="6" v-if="dump_by_stops_data.data !== undefined && widgets.includes('DumpByStops')">
              <div class="loading_page" v-if="dump_by_stops_data.loading">
                <orbit-spinner :animation-duration="1000" :size="100" :color="'#0e96b1'" />
              </div>
              <DumpByStopsWidget :data="dump_by_stops_data.data" />
            </b-col>

            <b-col lg="6" md="6" v-if="dump_by_reader_data.data !== undefined && widgets.includes('DumpByReader')">
              <div class="loading_page" v-if="dump_by_reader_data.loading">
                <orbit-spinner :animation-duration="1000" :size="100" :color="'#0e96b1'" />
              </div>
              <DumpByReaderWidget :data="dump_by_reader_data.data" />

            </b-col>
          


            <b-col lg="12" md="12" v-if="widgets.includes('Garden')">

              <div class="loading_page" v-if="garden_data.loading">
                <orbit-spinner :animation-duration="1000" :size="100" :color="'#0e96b1'" />
              </div>

              
              <garden-general-info :irrigation="irrigation_data.other_info" :garden="garden_data.other_info" />


            </b-col>

          </b-row>

          <b-row>
            <b-col cols="12">
              <div class="loading_page" v-if="garden_data.loading">
                <orbit-spinner :animation-duration="1000" :size="100" :color="'#0e96b1'" />
              </div>
              <div v-if="widgets.includes('Garden')">

                <div v-if="garden_data.data != undefined && garden_data.data.categories != undefined">
                  <garden-chart
                    :widgetLabels="{ planned: 'service count planed', served: 'service count served', complection: 'service count complection' }"
                    :barSeries="garden_data.data.series" title='Garden Data' :labels_data="garden_data.data.categories"
                    :other_data="[]" :listData="garden_data.data.lists" />
                </div>

              </div>
            </b-col>
          </b-row>


      <b-row>

        <b-col lg="12" md="12" v-if="summary_data.data !== undefined  && widgets.includes('ServiceSummary')">
              <div class="loading_page" v-if="summary_data.loading">
                <orbit-spinner :animation-duration="1000" :size="100" :color="'#0e96b1'" />
              </div>
              <GeneralServicesChart :data="summary_data.data"   :chartInfo="{title:'Containers',type:'summary'}" />

            </b-col>
      </b-row>


        </b-tab>

        <b-tab @click="changeTab('Regions')" v-if="showRegionsTab">
          <template #title>
            <feather-icon icon="GlobeIcon" size="33" />
            <span style="font-size:1.5rem"> {{ $t('Regions Statistics') }}</span>
          </template>



          <b-col lg="12" md="12" v-if="widgets.includes('Geofences')">
            <div class="loading_page" v-if="geofences_data.loading">
              <orbit-spinner :animation-duration="1000" :size="100" :color="'#0e96b1'" />
            </div>

            <div v-if="Object.keys(geofences_data.data).length !== 0">
              <geofences-statistics :info="geofences_data.data" :ser="[23, 5, 6, 7, 54]" />

            </div>
          </b-col>

        </b-tab>
      </b-tabs>

    </div>

  </section>
</template>

<script>
import { BRow, BCol, BTabs, BTab, BCardText } from 'bootstrap-vue'
import ContainersChart from './ContainersChart.vue'
import ContainersStatistics from './ContainersStatistics.vue'
import DevicesStatistics from './DevicesStatistics.vue'
import EcommerceGoalOverview from './EcommerceGoalOverview.vue'
import GeofencesStatistics from './GeofencesStatistics.vue'
import RainChart from './RainChart.vue'

import GeneralServicesChart   from './GeneralServicesChart'

import SweepChart from './SweepChart.vue'
import WashingChart from './WashingChart.vue'
import GardenGeneralInfo from './GardenGeneralInfo.vue'

import ContractsChart from './ContractsChart.vue'
import { mapGetters, mapActions } from 'vuex';
import { OrbitSpinner } from 'epic-spinners'
import ToggleCollapse from '@/views/ui/toggle-collapse/ToggleCollapse.vue'
import DashboardFilter from '@/views/dashboard/filter/DashboardFilter.vue'

import GardenChart from '@/views/dashboard/services/GardenChart.vue'

import AdvancedChart from '@/views/dashboard/services/AdvancedChart.vue'

import DashBoardData from './data'

import Category from './categories/Category.vue'
import DevicesStatisticsByCategory from './DevicesStatisticsByCategory.vue'
import DevicesStatisticsByCategoryCard from './DevicesStatisticsByCategoryCard.vue'
import { ref, onMounted, computed, onUnmounted, watch } from '@vue/composition-api'

import { DashboardService } from '@/views/dashboard/data/services'


import store from '@/store'
import { oB } from 'caniuse-lite/data/browserVersions'

import { useRouter } from '@core/utils/utils'

import DumpByStopsWidget from './widgets/dumpByStops/widget.vue'
import DumpByReaderWidget from './widgets/dumpByReader/widget.vue'
import SweepWidget from './widgets/Sweep/widget.vue'
import WashWidget from './widgets/Wash/widget.vue'


export default {
  components: {
    BRow,
    BCol,
    BTabs, BTab, BCardText,
    ContainersChart,
    DevicesStatistics,
    EcommerceGoalOverview,
    GeofencesStatistics,
    RainChart,
    SweepChart,
    WashingChart,
    OrbitSpinner,
    ToggleCollapse,
    DashboardFilter,
    ContractsChart,
    Category,
    GardenChart,
    GardenGeneralInfo,
    AdvancedChart,
    GeneralServicesChart,
    DumpByStopsWidget,
    DumpByReaderWidget,
    DevicesStatisticsByCategory,
    ContainersStatistics,
    DevicesStatisticsByCategoryCard,
    SweepWidget,
    WashWidget
  },



  data() {

    return {
      data: {},
      widgets: this.$store.state.auth.userData.widgets
    }
  },

  setup(props, { root }) {
    const windowFoucs = ref(true)
    const { route, router } = useRouter()
    const currentRoute = computed(() => {
      return route.value.path;
    })
    const isActiveTabe = ref(true)

    const showServicesTab = ref(false)
    const showDevicesTab = ref(false)
    const showRegionsTab = ref(false)

    const refmtab = ref("")


    const {
      devices_data
      , categories_data
      , currentTabe
      , sweep_data
      , rain_data
      , summary_data
      , wash_data
      , container_data
      , dump_by_stops_data
      , dump_by_reader_data
      , garden_data
      , irrigation_data
      , geofences_data
      , DevicesData
      , ServiceData
      , RegionData
    } = DashBoardData();




    const showTab = () => {
      const avaliableWidgets = store.state.auth.userData.widgets;

      const servicesAll = ["Containers", "Garden", "Rain", "Sweep", "Wash", "DumpByReader"];
      const devicesAll = ['Devices']
      const regionsAll = ['Geofences']

      avaliableWidgets.forEach(element => {

        if (servicesAll.includes(element)) {
          showServicesTab.value = true;

        }

        if (devicesAll.includes(element)) {
          showDevicesTab.value = true;

        }
        if (regionsAll.includes(element)) {
          showRegionsTab.value = true;

        }

      });


    }
    showTab();



    const selectFirstTabWillLoad = (manulaTab, forceload) => {
      let filter = store.getters['dashBoardFilter/getFilterData'];


      if (store.state.dashBoardFilter != undefined && store.state.dashBoardFilter.windowFoucs != undefined || forceload == true) {

        if (manulaTab == "") {



          if (showDevicesTab.value == true) {

            currentTabe.value = "Devices"
            store.dispatch("dashBoardFilter/setDashboardCurrentTab", "Devices")
            DevicesData(filter, true);

            return;


          } else if (showServicesTab.value == true) {
            currentTabe.value = "Services"
            store.dispatch("dashBoardFilter/setDashboardCurrentTab", "Services")
            ServiceData(filter, true)
            return;
          } else if (showRegionsTab.value == true) {

            currentTabe.value = "Regions"
            store.dispatch("dashBoardFilter/setDashboardCurrentTab", "Regions")
            RegionData(filter, true)
            return;
          }


        } else {
          // console.log('some prevusue tab',manulaTab)
          currentTabe.value = manulaTab;
          store.dispatch("dashBoardFilter/setDashboardCurrentTab", manulaTab)
          if (manulaTab == "Devices") { DevicesData(filter, true); }
          if (manulaTab == "Services") { ServiceData(filter, true); }
          if (manulaTab == "Regions") { RegionData(filter, true); }
        }
      }
    }
    //send request only if dashbord is active and visible and only for selected table (devices,services ..etc)
    function visibilityControl() {
      let mtab = ""
      if (document.hidden && store.state.dashBoardFilter != undefined) {

        store.dispatch("dashBoardFilter/setWindowFoucs", false)
      } else {
        if (store.state.dashBoardFilter != undefined) { store.dispatch("dashBoardFilter/setWindowFoucs", true) }
        if (store.state.dashBoardFilter != undefined) { mtab = store.state.dashBoardFilter.manulSelectedTab; }

        if (mtab !== "") {

          store.dispatch("dashBoardFilter/setDashboardCurrentTab", mtab)
        }
        selectFirstTabWillLoad(mtab, false);

      }
    }
    onUnmounted(() => {
      document.removeEventListener('visibilitychange', visibilityControl, true);
      document.removeEventListener('visibilitychange', visibilityControl, false);
    })





    onMounted(() => {

      if (store.state.dashBoardFilter != undefined) {

        //empty string mean let function deicde no tab seleted yet by user
        selectFirstTabWillLoad("", true)
        store.dispatch("dashBoardFilter/setWindowFoucs", true)
        document.addEventListener("visibilitychange", visibilityControl);
      }

    })



    const changeTab = (tabName) => {
      store.dispatch("dashBoardFilter/setManulSelectedTab", tabName)

      let filter = store.getters['dashBoardFilter/getFilterData'];
      if (tabName == "Services") {
        ServiceData(filter, true)
        currentTabe.value = "Services"

        store.dispatch("dashBoardFilter/setDashboardCurrentTab", "Services")



      } else if (tabName == "Regions") {

        currentTabe.value = "Regions"
        store.dispatch("dashBoardFilter/setDashboardCurrentTab", "Regions")
        RegionData(filter, true);
      }
      if (tabName == "Devices") {
        store.dispatch("dashBoardFilter/setDashboardCurrentTab", "Devices")
        currentTabe.value = "Devices"
        DevicesData(filter, true);
      }



    }

    const filterDashboard = (params) => {

      if (currentTabe.value == "Devices") {
        DevicesData(params, true)
      }

      if (currentTabe.value == "Services") {

        ServiceData(params, true)
      }
      if (currentTabe.value == "Regions") {
        RegionData(params, true);
      }


    }

    return {
      devices_data,
      categories_data,
      sweep_data,
      rain_data,
      wash_data,
      summary_data,
      container_data,
      dump_by_stops_data,
      dump_by_reader_data,
      garden_data,
      irrigation_data,
      geofences_data,
      changeTab,
      currentTabe,
      filterDashboard,
      showTab,
      showServicesTab,
      showDevicesTab,
      showRegionsTab,
      isActiveTabe,
      selectFirstTabWillLoad,
      currentRoute

    }
  }

}

</script>

<style lang="scss">
@import '@core/scss/vue/pages/dashboard-ecommerce.scss';
@import '@core/scss/vue/libs/chart-apex.scss';
</style>

